import { GLOBAL_VERSION_CONTEXT } from '@/components/webcomponents/Global/versioncontext'

/**
 * Get CDN base URL for asset loading
 * Provides fallback for when runtime config isn't loaded yet
 */
export function getCdnUrl(path: string = ''): string {
  const base = `${GLOBAL_VERSION_CONTEXT.CDN_ROOT}${GLOBAL_VERSION_CONTEXT.VERSION}`
  return path ? `${base}/${path.replace(/^\/+/, '')}` : base
}

/**
 * Get CSS-specific CDN URL
 * Uses CSS_PATH if available, otherwise falls back to CDN_ROOT + VERSION
 */
export function getCssUrl(path: string = ''): string {
  const cssBase = getCdnUrl(GLOBAL_VERSION_CONTEXT.CSS_PATH)
  return path ? `${cssBase}/${path.replace(/^\/+/, '')}` : cssBase
}

/**
 * Get JavaScript-specific CDN URL
 * Uses JS_PATH if available, otherwise falls back to CDN_ROOT + VERSION
 */
export function getJsUrl(path: string = ''): string {
  const jsBase = getCdnUrl(GLOBAL_VERSION_CONTEXT.JS_PATH)
  return path ? `${jsBase}/${path.replace(/^\/+/, '')}` : jsBase
}

export function getVersion(): { version: string } {
  return { version: GLOBAL_VERSION_CONTEXT.VERSION };
}

export function getEnvironment(): { environment: string } {
  return { environment: GLOBAL_VERSION_CONTEXT.ENVIRONMENT };
}